var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCheckboxChecked = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 0H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z",
  fill: "#4585FF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4585FF",
  d: "M17 1v16H1V1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.692 12.115l.004-.004-.004.004zM14.332 5l.668.625-7.56 7.074-.338.301L3 9.162l.668-.625 3.442 3.22L14.332 5z",
  fill: "#FFF",
  fillRule: "nonzero"
}))));
export default SvgIconCheckboxChecked;